import { render, staticRenderFns } from "./HoleEdit.vue?vue&type=template&id=183da5a4&"
import script from "./HoleEdit.vue?vue&type=script&lang=js&"
export * from "./HoleEdit.vue?vue&type=script&lang=js&"
import style0 from "./HoleEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports